module.exports = __webpack_public_path__ + "static/img/61.a7b2de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/61.png
// module id = 6elV
// module chunks = 0